export default __webpack_public_path__ + "static/media/assest.a83a2c0d.png";